'use client';

import { useSyncExternalStore } from 'react';

import { SEOLEIMRUN_APPLY_OPEN_AT, SEOLEIMRUN_END_AT, SEOLEIMRUN_FOOTER_NOTICE_OPEN_AT, SEOLEIMRUN_ROUNDS } from './constants';

interface EventPhase {
  /** 대회 종료(9/6~) 여부. 종료 시 액션 버튼 클릭 → 종료 모달. */
  isEnded: boolean;
  /** 현재 날짜 기준 회차 인덱스(0=1차). 경품 회차 탭 기본값. 회차 기간이 겹치면 신규 회차 우선. */
  currentRoundIndex: number;
  /** 접수 오픈(7/10 10:00~) 여부. 하단 공지사항/유의사항 버튼 노출 게이팅. */
  isFooterNoticeOpen: boolean;
  /** 참가 접수 오픈(7/13 10:00~) 여부. 히어로 신청하기 버튼 게이팅. */
  isApplyOpen: boolean;
}

// SSR 안전 + 하이드레이션 mismatch 방지: 서버는 기본 스냅샷(이벤트 시작 전), 클라이언트는 실제 날짜 기준.
// useSyncExternalStore 가 server→client 스냅샷 전환을 처리하므로 setState-in-effect 불필요.
const SERVER_PHASE: EventPhase = { isEnded: false, currentRoundIndex: 0, isFooterNoticeOpen: false, isApplyOpen: false };

// 클라이언트 스냅샷은 1회 계산 후 캐시 — Object.is 동일성 보장(무한 렌더 방지).
let clientPhase: EventPhase | null = null;

function getClientSnapshot(): EventPhase {
  if (!clientPhase) {
    const now = Date.now();
    // 회차 기간이 겹치므로(2차 시작 07/14 < 1차 종료 07/19) 종료일이 아닌 시작일 기준.
    // startAt 오름차순 전제 → 시작한 회차 수 - 1 = 가장 마지막에 시작한 회차. 시작 전(0개)이면 1차.
    const startedCount = SEOLEIMRUN_ROUNDS.filter((round) => now >= round.startAt).length;
    clientPhase = {
      isEnded: now >= SEOLEIMRUN_END_AT,
      currentRoundIndex: startedCount === 0 ? 0 : startedCount - 1,
      isFooterNoticeOpen: now >= SEOLEIMRUN_FOOTER_NOTICE_OPEN_AT,
      isApplyOpen: now >= SEOLEIMRUN_APPLY_OPEN_AT,
    };
  }
  return clientPhase;
}

// 날짜는 세션 중 한 번만 평가(라운드/종료 경계 전환은 새로고침 시 반영) → 구독 불필요(no-op).
const subscribe = () => () => {};

export function useEventPhase(): EventPhase {
  return useSyncExternalStore(subscribe, getClientSnapshot, () => SERVER_PHASE);
}
